module.exports = __webpack_public_path__ + "static/media/FB-Ad.9c12e35d.gif";